// Accordions
// script.js
document.querySelectorAll('.accordion-header').forEach((button, index) => {
    button.addEventListener('click', () => {
        const content = button.nextElementSibling; // Select the associated content
        const isOpen = content.classList.contains('open');

        // Close all other accordions
        document.querySelectorAll('.accordion-content.open').forEach((openContent) => {
            if (openContent !== content) {
                openContent.style.height = `${openContent.scrollHeight}px`; // Start from current height
                setTimeout(() => {
                    openContent.style.height = '0'; // Animate to closed state
                });
                openContent.classList.remove('open');
                openContent.previousElementSibling.classList.remove('active');
            }
        });

        if (!isOpen) {
            // Open the clicked accordion
            content.classList.add('open');
            button.classList.add('active');  // Add 'active' class to trigger the arrow rotation

            // Set the height to the scroll height for transition
            content.style.height = `${content.scrollHeight}px`;

            // Reset to 'auto' after the transition completes
            setTimeout(() => {
                content.style.height = 'auto';
            }, 300); // Match transition duration
        } else {
            // Close the clicked accordion
            content.style.height = `${content.scrollHeight}px`; // Set current height as starting point
            setTimeout(() => {
                content.style.height = '0'; // Collapse to 0
            });

            content.classList.remove('open');
            button.classList.remove('active');  // Remove 'active' class when closing
        }
    });

    // Automatically open the first accordion when the page loads
    if (index === 0) {
        const content = button.nextElementSibling;
        content.classList.add('open');
        button.classList.add('active');  // Ensure first section has active class for rotation
        content.style.height = `${content.scrollHeight}px`;
        setTimeout(() => {
            content.style.height = 'auto';
        }, 300); // Match transition duration
    }
});
// End Accordions

// TAB Script
    function openTab(evt, tabName) {
        // Declare variables
        var i, tabcontent, tablinks;

        // Hide all tab content
        tabcontent = document.getElementsByClassName("tab-content");
        for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].classList.remove("active");
        }

        // Remove the active class from all tab links
        tablinks = document.getElementsByClassName("tablinks");
        for (i = 0; i < tablinks.length; i++) {
            tablinks[i].classList.remove("active");
        }

        // Show the current tab content and add active class to the clicked tab link
        document.getElementById(tabName).classList.add("active");
        evt.currentTarget.classList.add("active");
    }

    // Set default tab
    var _defaultTab = document.getElementById("defaultTab"); if (_defaultTab) _defaultTab.click();
	
// End TAB Script	